/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the InventorySnapshotResponseDTO interface.
 */
export function instanceOfInventorySnapshotResponseDTO(value) {
    return true;
}
export function InventorySnapshotResponseDTOFromJSON(json) {
    return InventorySnapshotResponseDTOFromJSONTyped(json, false);
}
export function InventorySnapshotResponseDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'sellingPrice': json['sellingPrice'] == null ? undefined : json['sellingPrice'],
        'sellingPriceUsd': json['sellingPriceUsd'] == null ? undefined : json['sellingPriceUsd'],
        'costPrice': json['costPrice'] == null ? undefined : json['costPrice'],
        'purchasePriceUsd': json['purchasePriceUsd'] == null ? undefined : json['purchasePriceUsd'],
        'shippingPriceUsd': json['shippingPriceUsd'] == null ? undefined : json['shippingPriceUsd'],
        'saleTaxPriceUsd': json['saleTaxPriceUsd'] == null ? undefined : json['saleTaxPriceUsd'],
        'dutyUsd': json['dutyUsd'] == null ? undefined : json['dutyUsd'],
        'shippingCarrier': json['shippingCarrier'] == null ? undefined : json['shippingCarrier'],
        'totalCostUsd': json['totalCostUsd'] == null ? undefined : json['totalCostUsd'],
        'currencyRate': json['currencyRate'] == null ? undefined : json['currencyRate'],
        'profit': json['profit'] == null ? undefined : json['profit'],
        'profitUsd': json['profitUsd'] == null ? undefined : json['profitUsd'],
        'referralFee': json['referralFee'] == null ? undefined : json['referralFee'],
        'referralFeeUsd': json['referralFeeUsd'] == null ? undefined : json['referralFeeUsd'],
        'sellingPriceNetOfVat': json['sellingPriceNetOfVat'] == null ? undefined : json['sellingPriceNetOfVat'],
        'sellingPriceNetOfVatUsd': json['sellingPriceNetOfVatUsd'] == null ? undefined : json['sellingPriceNetOfVatUsd'],
        'vatAmount': json['vatAmount'] == null ? undefined : json['vatAmount'],
        'vatAmountUsd': json['vatAmountUsd'] == null ? undefined : json['vatAmountUsd'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
        'itemHeight': json['itemHeight'] == null ? undefined : json['itemHeight'],
        'itemLength': json['itemLength'] == null ? undefined : json['itemLength'],
        'itemWidth': json['itemWidth'] == null ? undefined : json['itemWidth'],
        'itemWeight': json['itemWeight'] == null ? undefined : json['itemWeight'],
        'rootCategory': json['rootCategory'] == null ? undefined : json['rootCategory'],
        'subCategory': json['subCategory'] == null ? undefined : json['subCategory'],
    };
}
export function InventorySnapshotResponseDTOToJSON(json) {
    return InventorySnapshotResponseDTOToJSONTyped(json, false);
}
export function InventorySnapshotResponseDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'sellingPrice': value['sellingPrice'],
        'sellingPriceUsd': value['sellingPriceUsd'],
        'costPrice': value['costPrice'],
        'purchasePriceUsd': value['purchasePriceUsd'],
        'shippingPriceUsd': value['shippingPriceUsd'],
        'saleTaxPriceUsd': value['saleTaxPriceUsd'],
        'dutyUsd': value['dutyUsd'],
        'shippingCarrier': value['shippingCarrier'],
        'totalCostUsd': value['totalCostUsd'],
        'currencyRate': value['currencyRate'],
        'profit': value['profit'],
        'profitUsd': value['profitUsd'],
        'referralFee': value['referralFee'],
        'referralFeeUsd': value['referralFeeUsd'],
        'sellingPriceNetOfVat': value['sellingPriceNetOfVat'],
        'sellingPriceNetOfVatUsd': value['sellingPriceNetOfVatUsd'],
        'vatAmount': value['vatAmount'],
        'vatAmountUsd': value['vatAmountUsd'],
        'imageUrl': value['imageUrl'],
        'itemHeight': value['itemHeight'],
        'itemLength': value['itemLength'],
        'itemWidth': value['itemWidth'],
        'itemWeight': value['itemWeight'],
        'rootCategory': value['rootCategory'],
        'subCategory': value['subCategory'],
    };
}
